module.exports = __webpack_public_path__ + "static/media/tablet2.db10389e.svg";